export default {
  // 標題
  tip: "提示",

  // 內容
  temporaryCanvasPrompt: "抱歉，當前為臨時畫布，請問是否需要保存該畫布？",
  exitTemporaryCanvasPrompt:
    "當前為臨時畫布，退出之後該畫布將不存在，如需保留請保存畫布。請問是否需要退出？",

  // 按鈕
  no: "否",
  yes: "是",
  exit: "退出",
  saveCanvas: "保存畫布",
};
